import {CircularProgress, makeStyles} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function Loading(): JSX.Element {
  const classes = useStyles();
  return (
    <div data-testid="loading-screen" className={classes.root}>
      <CircularProgress />
    </div>
  );
}
